import type { VideoData } from '@/frontend-types'
import { cx } from 'cva'
import type { ComponentProps, FC } from 'react'

export type VideoProps = Omit<ComponentProps<'video'>, 'src' | 'title'> & {
	video: VideoData
}

export const Video: FC<VideoProps> = ({ video, className, ...props }) => {
	return (
		<video
			src={video.src}
			title={video.title ?? undefined}
			preload="metadata"
			className={cx('h-full w-full object-cover', className)}
			{...props}
		>
			{video.subtitles?.map((subtitle, index) => (
				<track
					key={subtitle.id || index}
					kind="subtitles"
					src={subtitle.url || undefined}
					srcLang={subtitle.language}
					label={subtitle.language}
					default={index === 0}
				/>
			))}
		</video>
	)
}
